import { useEffect, useState } from "react";

export type UseMediaQueryOptions = {
  query: string;
};

export type UseMediaQueryResult = boolean;

const isValidMediaQueryString = (query: string): boolean => {
  return query !== "not all";
};

const useMediaQuery = ({ query }: UseMediaQueryOptions): UseMediaQueryResult => {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const mql = window.matchMedia(query);

    if (!isValidMediaQueryString(mql.media)) {
      throw new Error(`${query}: invalid media query string.`);
    }

    const detectMediaChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    setMatches(mql.matches);

    mql.addEventListener("change", detectMediaChange);
    return () => {
      mql.removeEventListener("change", detectMediaChange);
    };
  }, [query]);

  return matches;
};

export default useMediaQuery;
